import { defineComponent as _defineComponent } from 'vue'
import { IDeviceCount } from '@/store/modules/metrics/types';
import VueApexCharts from 'vue-apexcharts';
import Metrics from '@/mixins/Metrics';
import { onMounted, ref } from 'vue';
import useStore from '@/utils/store/common';
import MetricsHeader from './components/MetricsHeader.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DeviceCount',
  setup(__props) {

const store = useStore();

const chartOptions = ref({});
const data = ref({});

onMounted(async () => {
  const metrics: IDeviceCount = await store.dispatch('metrics/fetchDeviceCount');
  data.value = Metrics.transformDeviceCountData(metrics);
  chartOptions.value = Metrics.getBarChartOptions(metrics);
});

return { __sfc: true,store, chartOptions, data, VueApexCharts, MetricsHeader }
}

})